import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import { extendMoment } from 'moment-range';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { tooltipShow, tooltipHide } from '../../helpers/tooltips';
import ChartLoader from '../../loaders/ChartLoader';
import { statCampaignDetail } from '../../containers/Statistics/actions';
import ErrorComponent from '../../components/Error';
import { registrars } from '../../config';
// translate
import messages from './messages';

let ChartComponent = null;

const momentExt = extendMoment(moment);
const defaultPeriod = '3';
const defaultStatus = 'all';

class Statistics extends Component {
  static rangeDateByPeriod(period) {
    const currentDate = new Date().toISOString().slice(0, 10);
    const dateTo = moment(currentDate);
    const dateFrom = moment(currentDate).subtract(period, 'months');

    return { dateFrom, dateTo };
  }

  static convertDataByDays(data, range) {
    const dataCharts = new Map();
    Array.from(range.by('days')).forEach((item) => {
      dataCharts.set(item.format('YYYY-MM-DD'), [
        moment(item).format('DD MMM, YYYY'),
        { v: 0, f: '$0' },
      ]);
    });

    data.forEach((item) => {
      if (item.reward_status === 'approve') {
        const date = item.action_time.substr(0, 10);

        if (dataCharts.has(date)) {
          const dataItem = dataCharts.get(date);
          const amount = Number(item.webmaster_amount) + Number(dataItem[1].v);
          dataItem[1] = { v: amount, f: `$${Number(amount)}` };

          dataCharts.set(date, dataItem);
        }
      }
    });

    return Array.from(dataCharts.values());
  }

  static convertDataByMonths(data, range) {
    const dataCharts = new Map();
    Array.from(range.by('month')).forEach((item) => {
      dataCharts.set(item.format('YYYY-MM'), [
        moment(item).format('MMM, YYYY'),
        { v: 0, f: '$0' },
      ]);
    });

    data.forEach((item) => {
      if (item.reward_status === 'approve') {
        const date = item.action_time.substr(0, 7);

        if (dataCharts.has(date)) {
          const dataItem = dataCharts.get(date);
          const amount = Number(item.webmaster_amount) + Number(dataItem[1].v);
          dataItem[1] = { v: amount, f: `$${Number(amount)}` };

          dataCharts.set(date, dataItem);
        }
      }
    });

    return Array.from(dataCharts.values());
  }

  constructor(props) {
    super(props);
    const { intl } = props;

    this.periods = new Map([
      ['1', `30 ${intl.formatMessage(messages.days)}`],
      ['3', `90 ${intl.formatMessage(messages.days)}`],
      ['6', `180 ${intl.formatMessage(messages.days)}`],
      ['12', `365 ${intl.formatMessage(messages.days)}`],
    ]);

    this.statuses = new Map([
      ['all', 'All'],
      ['wait', 'In Progress'],
      ['approve', 'Available'],
      ['reject', 'Declined'],
      ['expired', 'Expired'],
    ]);

    this.onChangePeriod = this.onChangePeriod.bind(this);
    this.onChangeDateRange = this.onChangeDateRange.bind(this);
    this.onCloseDateRange = this.onCloseDateRange.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);

    const { dateFrom, dateTo } = this.constructor.rangeDateByPeriod(
      defaultPeriod,
    );

    this.dataCharts = null;

    this.state = {
      period: defaultPeriod,
      status: defaultStatus,
      dateFrom,
      dateTo,
      dateRangeFocused: null,
    };
  }

  componentWillMount() {
    if (ChartComponent === null) {
      ChartLoader().then((deps) => {
        ChartComponent = deps.chart.Chart;
        this.forceUpdate();
      });
    }

    const { status, dateFrom, dateTo } = this.state;
    this.fetchData(status, dateFrom, dateTo);
  }

  componentWillReceiveProps(nextProps, nextState) {
    const { status } = this.state;
    const statusChanged = status !== nextState.status;
    const dataChanged = this.props.data !== nextProps.data;

    if (dataChanged && status === 'all' && statusChanged) {
      this.dataCharts = this.convertData(nextProps.data);
    }
  }

  onChangePeriod(period) {
    const { dateFrom, dateTo } = this.constructor.rangeDateByPeriod(period);
    this.setState({ status: defaultStatus, period, dateFrom, dateTo });
    this.fetchData(defaultStatus, dateFrom, dateTo);
  }

  onChangeDateRange({ startDate, endDate }) {
    const { dateFrom, dateTo } = this.state;
    this.setState({
      status: defaultStatus,
      period: null,
      dateFrom: startDate || dateFrom,
      dateTo: endDate || dateTo,
    });
  }

  onCloseDateRange({ startDate, endDate }) {
    this.fetchData(this.state.status, startDate, endDate);
  }

  onChangeStatus(status) {
    this.setState({ status });
    const { dateFrom, dateTo } = this.state;
    this.fetchData(status, dateFrom, dateTo);
  }

  convertData(data) {
    const { dateFrom, dateTo } = this.state;
    const range = momentExt.range(dateFrom, dateTo);

    if (this.state.period === '1') {
      return this.constructor.convertDataByDays(data, range);
    }

    return this.constructor.convertDataByMonths(data, range);
  }

  calcStatus(item) {
    let dateEndAction = moment();

    const { campaign } = this.props;
    dateEndAction = moment(item.action_time).add(
      Number(campaign.time_for_action),
      's',
    );

    let status = item.reward_status;
    if (status === 'wait' && moment().diff(moment(dateEndAction)) > 0) {
      status = 'expired';
    }

    return status;
  }

  fetchData(status, dateFrom, dateTo) {
    const { dispatch, campaign } = this.props;

    dispatch(
      statCampaignDetail(
        campaign,
        status,
        dateFrom.format('YYYY-MM-DD'),
        dateTo.format('YYYY-MM-DD'),
      ),
    );
  }

  renderPeriods() {
    const { period } = this.state;
    const elements = [];

    let i = 0;
    this.periods.forEach((title, value) => {
      i += 1;
      elements.push(
        <li key={i} className={classNames({ active: period === value })}>
          <a
            role="button"
            tabIndex="0"
            onClick={() => this.onChangePeriod(value)}
          >
            {title}
          </a>
        </li>,
      );
    });

    return elements;
  }

  renderStatuses() {
    const { status } = this.state;
    const statuses = [];

    this.statuses.forEach((value, key) => {
      if (key !== 'expired') {
        statuses.push(
          <label
            key={value}
            className={classNames('checkbox-outer', {
              checked: status === key,
            })}
            htmlFor={`filter-status-${key}`}
          >
            <span className="checkbox-wrap">
              <input
                id={`filter-status-${key}`}
                type="checkbox"
                name="status"
                onClick={() => this.onChangeStatus(key)}
                defaultChecked={status === key}
              />
            </span>
            <span className="checkbox-desc">{value}</span>
          </label>,
        );
      }
    });

    return statuses;
  }

  render() {
    const { intl, isFetching, errorMessage, data } = this.props;
    const { dateRangeFocused, dateFrom, dateTo } = this.state;

    return (
      <div>
        <div className="container-fluid dashboard-chart">
          <div className="row">
            <div className="container">
              <div className="row">
                <p className="text-header">
                  <FormattedHTMLMessage {...messages.header} />
                </p>
                <div className="col-md-6">
                  <p className="dashpoard-title">Quick View</p>
                  <ul className="chart-list">
                    {this.renderPeriods()}
                  </ul>
                </div>

                <div className="col-md-6" style={{ textAlign: 'right' }}>
                  <p className="dashpoard-title">Range</p>

                  <DateRangePicker
                    readOnly
                    hideKeyboardShortcutsPanel
                    displayFormat="DD/MM/YYYY"
                    isOutsideRange={() => false}
                    startDate={dateFrom}
                    endDate={dateTo}
                    onClose={this.onCloseDateRange}
                    onDatesChange={this.onChangeDateRange}
                    focusedInput={dateRangeFocused}
                    onFocusChange={focusedInput =>
                      this.setState({ dateRangeFocused: focusedInput })}
                  />
                </div>

                <span className="clearfix" />

                {this.dataCharts &&
                  this.dataCharts.length > 0 &&
                  ChartComponent &&
                  <div className="chart-wrap">
                    <ChartComponent
                      chartType="ColumnChart"
                      data={[['Days', 'Reward'], ...this.dataCharts]}
                      options={{
                        title: '',
                        pointSize: 4,
                        hAxis: {
                          title: '',
                        },
                        vAxis: {
                          title: '',
                          format: 'currency',
                        },
                        legend: 'none',
                      }}
                      graph_id="chart"
                      width="100%"
                      height="100%"
                      loader={<div />}
                    />
                  </div>}

              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid dashborad-table-wrap">
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <div className="dashborad-table-filter-wrap">
                    {this.renderStatuses()}
                  </div>

                  {errorMessage &&
                    !isFetching &&
                    <ErrorComponent>{errorMessage}</ErrorComponent>}

                  <table className="dashboard-table">
                    <thead>
                      <tr>
                        <td className="date">
                          {intl.formatMessage(messages.date)}
                        </td>
                        <td className="domain">
                          {intl.formatMessage(messages.domain)}
                        </td>
                        <td className="registrar">
                          {intl.formatMessage(messages.registrar)}
                        </td>
                        <td
                          className="price has-tooltip"
                          onMouseEnter={tooltipShow}
                          onMouseLeave={tooltipHide}
                          data-tooltip={intl.formatMessage(
                            messages.priceTooltip,
                          )}
                        >
                          {intl.formatMessage(messages.price)}
                        </td>
                        <td
                          className="commusion has-tooltip"
                          onMouseEnter={tooltipShow}
                          onMouseLeave={tooltipHide}
                          data-tooltip={intl.formatMessage(
                            messages.commisionTooltip,
                          )}
                        >
                          {intl.formatMessage(messages.commision)}
                        </td>
                        <td className="status">
                          {intl.formatMessage(messages.status)}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching &&
                        <tr>
                          <td colSpan="6" style={{ textAlign: 'center' }}>
                            {intl.formatMessage(messages.loading)}
                          </td>
                        </tr>}

                      {!isFetching &&
                        data.length === 0 &&
                        <tr>
                          <td colSpan="6" style={{ textAlign: 'center' }}>
                            {intl.formatMessage(messages.noData)}
                          </td>
                        </tr>}

                      {!isFetching &&
                        data.map((item) => {
                          const status = this.calcStatus(item);
                          return (
                            <tr key={item.action_id} data-status={status}>
                              <td className="date">
                                {moment(item.action_time).format(
                                  'DD/MM/YYYY hh:mm',
                                )}
                              </td>
                              <td className="domain">
                                {item.partner_custom.length &&
                                  item.partner_custom.split(';')[0].slice(2)}
                              </td>
                              <td className="registrar">
                                {item.partner_custom.length &&
                                  registrars.get(
                                    item.partner_custom.split(';')[1].slice(2),
                                  )}
                              </td>
                              <td className="price">
                                {item.partner_order_sum > 0
                                  ? `$${Number(item.partner_order_sum)}`
                                  : 'N/A'}
                              </td>
                              <td className="commusion">
                                ${Number(item.webmaster_amount)}
                              </td>
                              <td className="status">
                                {this.statuses.get(status)}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Statistics.defaultProps = {
  errorMessage: false,
};

Statistics.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  isFetching: PropTypes.bool.isRequired,
  errorMessage: PropTypes.any,
  data: PropTypes.array.isRequired,
  campaign: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    isFetching: state.get('statistics').isFetching,
    errorMessage: state.get('statistics').errorMessage,
    data: state.get('statistics').data,
  };
}

export default connect(mapStateToProps)(injectIntl(withRouter(Statistics)));



// WEBPACK FOOTER //
// ./src/containers/Statistics/index.js